import Console from '@/views/console'
import ConsoleHome from '@/views/console/home'
import FlowDetail from '@/views/console/flowDetail'
import FlowManage from '@/views/console/flowManage'
import Key from '@/views/console/key'

export default {
  path: '/console',
  component: Console,
  redirect: '/console/home',
  children: [
    { path: '/console/key', component: Key },
    { path: '/console/flowdetail/:active', component: FlowDetail, props: true },
    { path: '/console/flowmanage', component: FlowManage, name: 'flowmanage' },
    { path: '/console/home', component: ConsoleHome }
  ]
}
